const MFERoutesEnum = {
    criticalComms: '/criticalcomms',
    riskIntelligence: '/riskintelligence',
    controlCenter: '/controlcenter'
};

export default MFERoutesEnum;
